import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {

    selectedItem: number;

    previousFirstLevel = 0;
    previousSecondLevel = 0;

    get ls(){ return localStorage }
    constructor(private authService: AuthService, private router: Router) {
        if(window.location.pathname != '/login' && !this.isAuth) router.navigate(['/login']);
    }

    get user() {
        return this.authService.currentUser;
    }

    ngOnInit() {

    }

    get isAuth() {
        return this.authService.currentUser;
    }

    onRouteBack(){
        this.router.navigate([localStorage.routeBack]);
        delete localStorage.routeBack;
    }

    onUpdate(){
        if(!confirm('¿Actualizar?, guarde sus cambios.')) return;
        window.location.reload();
    }
    onLogout() {
        this.authService.signOut();
    }
    onSudo(){
        this.router.navigate(['/superadmin']);
    }

    menuSelected(id) {
        this.selectedItem = id;

        const closeMenu = document.getElementById('sidenav-overlay');
        closeMenu.click();
    }

    toogleFirstLvl(selectedItem) {
        if (this.previousSecondLevel !== 0) {
            const activeList = document.getElementsByClassName('second-lvl-item active');

            if (activeList.length > 0) {
                const activeItem = activeList[0] as HTMLElement;
                activeItem.click();
            }
        }

        if (this.previousFirstLevel !== selectedItem) {
            const activeList = document.getElementsByClassName('first-lvl-item active');

            if (activeList.length > 0) {
                const activeItem = activeList[0] as HTMLElement;
                activeItem.click();
            }

            this.previousFirstLevel = selectedItem;
        } else {
            this.previousFirstLevel = 0;
        }
    }

    toogleSecondLvl(selectedItem) {
        if (this.previousSecondLevel !== selectedItem) {
            const activeList = document.getElementsByClassName('second-lvl-item active');

            if (activeList.length > 0) {
                const activeItem = activeList[0] as HTMLElement;
                activeItem.click();
            }

            this.previousSecondLevel = selectedItem;
        } else {
            this.previousSecondLevel = 0;
        }
    }

}
